/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from "react";

import { Fade } from "react-awesome-reveal";

import Button from "../elements/Button";

import CNCHero from "../assets/images/hero/CNCHero.webp";

export default function Hero() {
  return (
    <section className="hero">
      <div className="w-full lg:w-1/2 xl:pl-12 sm:pr-2 mt-8">
        <h1 className="text-5xl sm:text-6xl text-theme-blue font-bold leading-tight mb-5">
          Teknisi CNC <br />
          Profesional Indonesia
        </h1>

        <p className="font-light text-xl text-gray-400 leading-relaxed mb-16">
          Kami menyediakan jasa service, perbaikan, maintenance, dan custom upgrade
          untuk menjaga mesin CNC Anda tetap beroperasi pada performa maksimal.
        </p>
        <Fade direction="up" delay={500} triggerOnce>
          <Button
            href="/project"
            type="link"
            className="inline-flex items-center justify-center px-8 py-4 text-white text-lg font-semibold bg-theme-purple rounded-xl shadow-2xl hover:bg-dark-theme-purple hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
          >
            Lihat Layanan
            <svg
              className="ml-3 w-5 h-5 text-white animate-bounce-x"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Button>
        </Fade>
      </div>
      <div className="flex pt-5 md:w-fit w-full justify-center items-center order-first md:order-first lg:order-last lg:w-1/2">
        <Fade direction="up" triggerOnce>
          <img 
            className="" 
            src={CNCHero} 
            alt="Teknisi CNC Service - Jasa Perbaikan dan Maintenance Mesin CNC Indonesia"
            width="600" 
            height="400"
            fetchPriority="high"
          />
        </Fade>
      </div>
    </section>
  );
}
